import toast from '@liquidweb-dev/undercurrent/toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type {
	LWApiPublicSecureDataShareExpireParamsRawI,
	LWApiPublicSecureDataShareExpireResultRawI,
} from '@liquidweb-dev/club-sauce/public/secureDataShare/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import { actions as accountDetailsActions } from 'modules/api/account/detailsModule';
import api from 'modules/queries/api';
import { ACCOUNT_DETAILS_QUERY_KEY } from 'modules/queries/account/useDetails';
import { useDispatch } from 'react-redux';
import useSnackbarError from 'utility/hooks/useSnackbarError';
import { SECURE_DATA_SHARE_LIST_QUERY_KEY } from './useList';

const useSecureDataShareExpire = () => {
	const snackbarError = useSnackbarError();
	const queryClient = useQueryClient();
	const dispatch = useDispatch();

	return useMutation<
		LWApiPublicSecureDataShareExpireResultRawI,
		ApiErrorI,
		LWApiPublicSecureDataShareExpireParamsRawI
	>({
		mutationFn: (params) => api.secureDataShare.apiRaw.expire(params),
		onSuccess: () => {
			queryClient.invalidateQueries({
				queryKey: [SECURE_DATA_SHARE_LIST_QUERY_KEY],
			});

			toast.success('Successfully deleted Secure Note');
		},
		onError: snackbarError,

		onSettled: () => {
			queryClient.invalidateQueries({
				queryKey: [
					ACCOUNT_DETAILS_QUERY_KEY,
					{
						alsowith: [
							'managementPortal',
							'businessUnit',
							'customerLifecycle',
							'highlights',
							'referAFriend',
						],
					},
				],
			});

			// TODO DEV-3707 - remove once we no longer fetch account/details with redux api pattern
			dispatch(
				accountDetailsActions.invalidate({
					alsowith: [
						'managementPortal',
						'businessUnit',
						'customerLifecycle',
						'highlights',
						'referAFriend',
					],
				}),
			);
		},
	});
};

export default useSecureDataShareExpire;
